import { render } from "./BoardMachine.vue?vue&type=template&id=00dba71f"
import script from "./BoardMachine.vue?vue&type=script&lang=js"
export * from "./BoardMachine.vue?vue&type=script&lang=js"

import "./BoardMachine.vue?vue&type=style&index=0&id=00dba71f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__